<template>
  <!-- HEADER -->
  <div class="header">
    <div class="container-fluid">
      <!-- Body -->
      <!-- / .row -->

      <!-- Filter -->
      <!-- end of filter -->

      <!-- Table -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Training</h4>
          <!-- Button -->
          <b-button variant="primary" @click="addTraining" v-if="listTabMenu?.privilages?.create">
            <span class="fe fe-file-plus"></span>
            Add Training
          </b-button>
        </div>
        <div class="row mb-3 mt-3 px-4">
          <div class="col-lg-3">
            <v-select
              v-model="body.platform"
              :options="['Ugems University', 'My Learning', 'Other']"
              :reduce="(e) => e"
              placeholder="Select Platform"
              @input="getTraining()">
            </v-select>
          </div>
          <div class="col-lg-3">
            <v-select
              v-model="body.provider"
              :options="dataProvider"
              :reduce="(e) => e.id"
              label="name"
              placeholder="Select Provider"
             @input="getTraining()">
            </v-select>
          </div>
          <div class="col-lg-3">
            <v-select
              v-model="body.training_method"
              :options="dataTrainingMethod"
              :reduce="(e) => e.id"
              label="name"
              placeholder="Select Training Method"
             @input="getTraining()">
            </v-select>
          </div>
          <div class="col-lg-3">
            <v-select
              v-model="body.training_type"
              :options="dataTrainingType"
              :reduce="(e) => e.id"
              label="name"
              placeholder="Select Training Type"
             @input="getTraining()">
            </v-select>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
          <label class="align-self-center mb-0 mr-3">Search</label>
            <b-form-input class="w-auto mb-0 mr-3" v-model="body.search" placeholder="Type Here..." @input="getTraining()">
          </b-form-input>
          <div class="col-lg-3">
            <v-select
              v-model="body.status"
              :options="[
                { id: true, name: 'Active' },
                { id: false, name: 'Non Active' }
              ]"
              :reduce="(e) => e.id"
              label="name"
              placeholder="Select Status"
              @input="getTraining()">
            </v-select>
          </div>
          <b-button variant="primary" @click="clearFilter">
            <span class="fe fe-x-square"></span>
            Clear Filter
          </b-button>
        </div>
        <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :total-rows="training.total"  
          :rows="training.data"
          :sort-options="{
            enabled: true
          }"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            position: 'bottom',
            perPage: body.pageSize,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All'
          }"
          style-class="vgt-table border-0 table"
          @on-sort-change="onSortChange"
          @on-page-change="onPageChange"
          @on-per-page-change="onPageChange">
          
          <!-- @on-page-change="onPageChange" -->
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>

          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span
              v-if="props.column.field == 'action'"
              class="d-flex justify-content-center align-items-center">
              <b-button
                v-if="listTabMenu.privilages.update"
                class="no-wrap btn-pill"
                variant="warning"
                size="sm"
                title="Perbarui Pelatihan"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
              <b-button
                v-if="listTabMenu.privilages.create"
                class="no-wrap ml-2"
                variant="info"
                size="sm"
                title="Add Schedule"
                @click="viewDetails(props.row)">
                <span class="fe fe-plus-circle"></span>
              </b-button>
              <b-button
                v-if="props.row.platform === 'Other'"
                class="no-wrap ml-2"
                variant="primary"
                size="sm"
                title="Proposed"
                @click="viewDetailsPropossed(props.row)">
                <span class="fe fe-eye"></span>
              </b-button>
            </span>
            <span v-else-if="props.column.field == 'training_method'">
              <span :class="getBadgeStatus(props.row.training_method)">
              <!-- <span> -->
                <i
                  :class="getIconClass(props.row.training_method)"
                  class="me-1"></i>
                <!-- {{ props.row.training_method }} -->
              </span>
            </span>
            <span v-else-if="props.column.field == 'training_type'">
              <span :class="getBadgeStatus(props.row.training_type)">
                <!-- <span> -->
                <i
                  :class="getIconClass(props.row.training_type)"
                  class="me-1"></i>
                <!-- {{ props.row.training_type }} -->
              </span>
            </span>
            <span v-else-if="props.column.field == 'hour'">
              {{ Math.round(props.row.hour) }}
            </span>
            <span v-else-if="props.column.field == 'is_active'">
              {{ props.row.is_active ? "Active" : "Non-active" }}
            </span>
          </template>
           <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-end">
                <div>
                  <b-pagination :value="1" :total-rows="training.total" :per-page="body.pageSize" first-number
                    last-number align="right" prev-class="prev-item" next-class="next-item" class="m-3" @input="
                      (value) => props.pageChanged({ currentPage: value })
                    ">
                  </b-pagination>
                </div>
              </div>
            </template>
        </vue-good-table>
        <div class="px-4">
          Training Type
          <div class="d-flex">
            <span :class="`mt-2 ${getBadgeStatus('Seminar')}`">
                <i :class="getIconClass('Seminar')"></i>
            </span>
            <span class="ml-2 mt-2">: Seminar</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('Workshop')}`">
                <i :class="getIconClass('Workshop')"></i>
            </span>
            <span class="ml-2 mt-2">: Workshop</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('Certification')}`">
                <i :class="getIconClass('Certification')"></i>
            </span>
            <span class="ml-2 mt-2">: Certification</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('SemiCertification')}`">
                <i :class="getIconClass('SemiCertification')"></i>
            </span>
            <span class="ml-2 mt-2">: Semi Certification</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('Trainings')}`">
                <i :class="getIconClass('Trainings')"></i>
            </span>
            <span class="ml-2 mt-2">: Trainings</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('Training')}`">
                <i :class="getIconClass('Training')"></i>
            </span>
            <span class="ml-2 mt-2">: Training</span>
          </div>
        </div>
        <div class="px-4">
          Training Method
          <div class="d-flex">
            <span :class="`mt-2 ${getBadgeStatus('SelfLearning')}`">
              <i :class="getIconClass('SelfLearning')"></i>
            </span>
            <span class="ml-2 mt-2">: Self Learning</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('In-ClassLearning')}`">
              <i :class="getIconClass('In-ClassLearning')"></i>
            </span>
            <span class="ml-2 mt-2">: In-Class Learning</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('OnlineLearning')}`">
              <i :class="getIconClass('OnlineLearning')"></i>
            </span>
            <span class="ml-2 mt-2">: Online Learning</span>
            <span :class="`mt-2 ml-3 ${getBadgeStatus('In-HouseLearning')}`">
              <i :class="getIconClass('In-HouseLearning')"></i>
            </span>
            <span class="ml-2 mt-2">: In-House Learning</span>
          </div>
        </div>
      </div>

      <!-- Modal Schedule -->
      <!-- <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal> -->

      <!-- Modal Schedule -->
      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="row">
          <div class="col-lg-4 col-12">
            <div class="form-group">
              <p class="form-label">Date <span class="text-danger">*</span></p>
              <v-date-picker
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
          </div>
          <div class="col-lg-4 col-12" v-if="schedule.date">
            <div class="form-group">
              <p class="form-label">Start Time <span class="text-danger">*</span></p>
              <v-date-picker
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
          </div>
          <div class="col-lg-4 col-12" v-if="schedule.date">
            <div class="form-group">
              <p class="form-label">End Time <span class="text-danger">*</span></p>
              <v-date-picker
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
        </div>
        <div class="mt-4">
          <b-button class="float-end" @click="addSchedule" variant="primary"
            >Add</b-button
          >
        </div>
        <div class="form-group">
        </div>
      </b-modal>
      <!-- Modal Create Event -->
      <b-modal
        v-model="isEnrollModalVisible"
        title="Create Event"
        size="lg"
        hide-footer
        @hide="clearEnrollModal">
        <!-- {{ selectedRow }} -->
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <label class="form-label">Training Title</label>
              <input
                v-model="bodyEnroll.trainingTitle"
                type="text"
                class="form-control"
                placeholder="Training Title"
                disabled />
            </div>
            <div class="col-6">
              <label class="form-label">Training Provider</label>
              <input
                v-model="bodyEnroll.trainingProvider"
                type="text"
                class="form-control"
                placeholder="Training Provider"
                disabled />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training Method <span class="text-danger">*</span></label>
              <v-select
                v-model="bodyEvent.trainingMethod"
                :options="dataTrainingMethod"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Training Method" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Price <span class="text-danger">*</span></label>
              <input
                v-model="bodyEvent.price"
                type="number"
                class="form-control"
                placeholder="Price" />
            </div>
            <div class="col-12 mt-4">
              <label class="form-label">Location <span class="text-danger">*</span></label>
              <input
                v-model="bodyEvent.location"
                type="text"
                class="form-control"
                placeholder="Location" />
            </div>
            <div class="col-12 mt-4">
              <label class="form-label">Quota <span class="text-danger">*</span></label>
              <input
                v-model="bodyEvent.quota"
                type="number"
                class="form-control"
                placeholder="Quota" />
            </div>
          </div>
          <div class="mt-4">
            <b-button @click="showScheduleModal" variant="primary"
              ><span class="fe fe-plus"></span>Add Schedule</b-button
            >
          </div>

          <!-- Schedule Table -->
          <div class="mt-4">
            <h4>Schedule</h4>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th style="width: 50px">Action</th>
                </tr>
              </thead>
              <tbody>
                  <tr v-if="scheduleList.length === 0">
                    <td class="text-center" colspan="4">No Data Available</td>
                  </tr>
                  <template v-else>
                  <tr v-for="(item, index) in scheduleList" :key="index">
                    <td>{{ item.date }}</td>
                    <td>{{ item.startTime }}</td>
                    <td>{{ item.endTime }}</td>
                    <td>
                      <button
                        @click="removeSchedule(index)"
                        class="btn btn-sm btn-danger">
                        <span class="fe fe-trash"></span>
                      </button>
                    </td>
                  </tr>
                  </template>
              </tbody>
            </table>
          </div>

          <!-- Participants Table -->
          <!-- <div class="mt-4">
          <h4>Participants</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="selectedParticipants.length === 0">
                <td class="text-center" colspan="2">No Data Available</td>
              </tr>
              <tr
                v-else
                v-for="(participant, index) in selectedParticipants"
                :key="index">
                <td>{{ participant.employee_name }}</td>
                <td>{{ participant.employee_position }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
        </div>
        <div class="mt-4 float-end">
          <b-button
            class="mr-3"
            @click="isEnrollModalVisible = false"
            variant="secondary"
            >Cancel</b-button
          >
          <b-button @click="submitEvent" variant="primary"
            ><span class="fe fe-save mr-1"></span>Submit</b-button
          >
        </div>
      </b-modal>

      <!-- Modal Add Training -->
      <b-modal
        v-model="isCreateModal"
        title="Buat Pelatihan"
        hide-footer
        size="xl"
        centered>
        <div class="form-group">
          <!-- Bagian 1 -->
          <div class="row">
            <div class="d-flex justify-content-between">
              <h3 class="mt-2">Competency</h3>
              <b-button variant="primary" @click="addCompetency">
                <span class="fe fe-file-plus"></span>
                Add Competency
              </b-button>
            </div>
            <template v-for="(item, index) in bodyAdd.competency" >
              <div class="col-5 mb-3">
                <label class="form-label">Competency {{ index+1 }}</label>
                <v-select
                  v-model="item.id"
                  :options="dataCompetency"
                  label="name"
                  :reduce="(e) => e.id"
                  placeholder="Select Competency" />
              </div>
              <div class="col-5 mb-3">
                <label class="form-label tex">Proficiency {{ index+1 }}<span class="text-danger">*Select one or more proficiency</span></label>
                <div class="button-container">
                  <div
                    v-for="num in 5"
                    :key="num"
                    class="button"
                    :class="{ active: item.proficiency.includes(num) }"
                    @click="toggleProficiency(num, index)">
                    {{ num }}
                  </div>
                </div>
                <!-- <p>Selected Proficiencies: {{ this.bodyAdd.proficiency }}</p> -->
              </div>
              <div class="col-2 mb-3" v-if="index != 0">
                <label></label>
                <b-button variant="primary" @click="delCompetency(index)" class="mt-2">
                  <span class="fe fe-trash"></span>
                </b-button>
              </div>
            </template>
          </div>
          <div class="row">
            <h3 class="mt-4">Provider</h3>

            <div class="col-6 mt-3">
              <label class="form-label">Provider</label>
              <v-select
                v-model="bodyAdd.provider"
                :options="dataProvider"
                label="name"
                @input="selectProvider"
                :reduce="(e) => e.id"
                placeholder="Select Provider" />
            </div>

            <div class="col-6 mt-3">
              <label class="form-label">Provider Name</label>
              <input
                v-model="bodyAdd.providerName"
                type="text"
                class="form-control"
                placeholder="Provider Name"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Address</label>
              <input
                type="text"
                v-model="bodyAdd.address"
                class="form-control"
                placeholder="Address"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Provider Website</label>
              <input
                type="text"
                v-model="bodyAdd.websiteProvider"
                class="form-control"
                placeholder="Provider Website"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Contact Person</label>
              <input
                type="text"
                v-model="bodyAdd.contactPerson"
                class="form-control"
                placeholder="Contact Person"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Email</label>
              <input
                type="text"
                v-model="bodyAdd.email"
                class="form-control"
                placeholder="Email"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Phone</label>
              <input
                type="number"
                class="form-control"
                v-model="bodyAdd.phone"
                placeholder="Phone"
                :disabled="bodyAdd.provider !== 'Other'" />
            </div>
          </div>

          <!-- Bagian 2 -->
          <!-- <div class="col-6 mt-3">
              <label for=""
                >Training
                <span class="text-danger"> *Search Training If Exist</span>
              </label>
              <v-select
                v-model="selectedLearning"
                :options="dataTraining"
                label="title"
                @input="selectTraining"
                @search="searchTraining"
                placeholder="Search Training">
              </v-select>
            </div> -->
          <div class="row">
            <h3 class="mt-4">Training</h3>
            <div class="col-6 mt-3">
              <label class="form-label">Training Provider ID</label>
              <input
                type="text"
                v-model="bodyAdd.lms_id"
                class="form-control"
                :class="{ 'is-invalid': isLmsIdRequired && !bodyAdd.lms_id }"
                placeholder="Training Provider ID"
                />
              <div
                v-if="isLmsIdRequired && !bodyAdd.lms_id"
                class="invalid-feedback">
                Training Provider ID is required when Provider is Ugems
                University.
              </div>
            </div>
            <div class="col-6 mt-2">
              <label class="form-label">Training Name</label>
              <input
                type="text"
                class="form-control"
                v-model="bodyAdd.trainingName"
                placeholder="Training Name" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training Method</label>
              <v-select
                v-model="bodyAdd.learningMethod"
                :options="dataTrainingMethod"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Training Method" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training Type</label>
              <v-select
                v-model="bodyAdd.learningType"
                :options="dataTrainingType"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Training Type" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Price</label>
              <div class="d-flex">
                <v-select
                  type="text"
                  style="width: 140px; color: gray"
                  :options="currencies"
                  v-model="bodyAdd.currency"
                  class="mr-2" />
                <input
                  type="text"
                  v-model="displayAmountAdd"
                  @input="updateAmount($event)"
                  class="form-control"
                  placeholder="Input Price (Numeric)" />
              </div>
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training URL</label>
              <input
                type="text"
                class="form-control"
                v-model="bodyAdd.websiteTraining"
                placeholder="Website" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Learning Hours</label>
              <input
                v-model="bodyAdd.hours"
                type="number"
                class="form-control"
                placeholder="Input Hours" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Status</label>
              <v-select
                :options="statusOptions"
                v-model="bodyAdd.status"
                label="text"
                :reduce="(e) => e.value"
                class="mr-2" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Description</label>
              <textarea
                v-model="bodyAdd.description"
                type="text"
                class="form-control"
                placeholder="Input Description" />
            </div>
          </div>
        </div>
        <b-button class="float-end" variant="primary" @click="createTraining()"
          >Submit
        </b-button>
      </b-modal>
      <!-- Modal Perbarui Pelatihan -->
      <b-modal
        v-model="isUpdateModal"
        title="Perbarui Pelatihan"
        hide-footer
        size="xl"
        centered>
        <div class="form-group">
          <!-- Bagian 1 -->
          <div class="row">
            <div class="d-flex justify-content-between">
              <h3 class="mt-2">Competency</h3>
              <b-button variant="primary" @click="addCompetencyUpdate">
                <span class="fe fe-file-plus"></span>
                Add Competency
              </b-button>
            </div>
            <template v-for="(item, index) in bodyUpdate.competency" >
              <div class="col-5 mb-3">
                <label class="form-label">Competency {{ index+1 }}</label>
                <v-select
                  v-model="item.id"
                  :options="dataCompetency"
                  label="name"
                  :reduce="(e) => e.id"
                  placeholder="Select Competency" />
              </div>
              <div class="col-5 mb-3">
                <label class="form-label tex">Proficiency {{ index+1 }}<span class="text-danger">*Select one or more proficiency</span></label>
                <div class="button-container">
                  <div
                    v-for="num in 5"
                    :key="num"
                    class="button"
                    :class="{ active: item.proficiency.includes(num) }"
                    @click="toggleProficiencyUpdate(num, index)">
                    {{ num }}
                  </div>
                </div>
                <!-- <p>Selected Proficiencies: {{ this.bodyAdd.proficiency }}</p> -->
              </div>
              <div class="col-2 mb-3" v-if="index != 0">
                <label></label>
                <b-button variant="primary" @click="delCompetencyUpdate(index)" class="mt-2">
                  <span class="fe fe-trash"></span>
                </b-button>
              </div>
            </template>
          </div>
          <div class="row">
            <h3 class="mt-4">Provider</h3>

            <div class="col-6 mt-3">
              <label class="form-label">Provider</label>
              <v-select
                v-model="bodyUpdate.provider"
                :options="dataProvider"
                label="name"
                @input="selectProvider"
                :reduce="(e) => e.id"
                placeholder="Select Provider" />
            </div>

            <div class="col-6 mt-3">
              <label class="form-label">Provider Name</label>
              <input
                v-model="bodyUpdate.providerName"
                type="text"
                class="form-control"
                placeholder="Provider Name"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Address</label>
              <input
                type="text"
                v-model="bodyUpdate.address"
                class="form-control"
                placeholder="Address"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Provider Website</label>
              <input
                type="text"
                v-model="bodyUpdate.websiteProvider"
                class="form-control"
                placeholder="Provider Website"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Contact Person</label>
              <input
                type="text"
                v-model="bodyUpdate.contactPerson"
                class="form-control"
                placeholder="Contact Person"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Email</label>
              <input
                type="text"
                v-model="bodyUpdate.email"
                class="form-control"
                placeholder="Email"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Phone</label>
              <input
                type="number"
                class="form-control"
                v-model="bodyUpdate.phone"
                placeholder="Phone"
                :disabled="bodyUpdate.provider !== 'Other'" />
            </div>
          </div>

          <!-- Bagian 2 -->
          <!-- <div class="col-6 mt-3">
              <label for=""
                >Training
                <span class="text-danger"> *Search Training If Exist</span>
              </label>
              <v-select
                v-model="selectedLearning"
                :options="dataTraining"
                label="title"
                @input="selectTraining"
                @search="searchTraining"
                placeholder="Search Training">
              </v-select>
            </div> -->
          <div class="row">
            <h3 class="mt-4">Training</h3>
            <div class="col-6 mt-3">
              <label class="form-label">Training Provider ID</label>
              <input
                type="text"
                v-model="bodyUpdate.lms_id"
                class="form-control" 
                placeholder="Training Provider ID"
                :class="{
                  'is-invalid': isLmsIdUpdateRequired && !bodyUpdate.lms_id
                }"
                />
              <div
                v-if="isLmsIdUpdateRequired && !bodyUpdate.lms_id"
                class="invalid-feedback">
                Training Provider ID is required when Provider is Ugems
                University.
              </div>
            </div>
            <div class="col-6 mt-2">
              <label class="form-label">Training Name</label>
              <input
                type="text"
                class="form-control"
                v-model="bodyUpdate.trainingName"
                placeholder="Training Name" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training Method</label>
              <v-select
                v-model="bodyUpdate.learningMethod"
                :options="dataTrainingMethod"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Training Method" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training Type</label>
              <v-select
                v-model="bodyUpdate.learningType"
                :options="dataTrainingType"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Training Type" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Price</label>
              {{displayAmountUpdate}}
              <div class="d-flex">
                <v-select
                  type="text"
                  style="width: 140px; color: gray"
                  :options="currencies"
                  v-model="bodyUpdate.currency"
                  class="mr-2" />
                <input
                  type="text"
                  v-model="displayAmountUpdate"
                  @input="updateAmount($event)"
                  class="form-control"
                  placeholder="Input Price (Numeric)" />
              </div>
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Training URL</label>
              <input
                type="text"
                class="form-control"
                v-model="bodyUpdate.websiteTraining"
                placeholder="Website" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Learning Hours</label>
              <input
                v-model="bodyUpdate.hours"
                type="number"
                class="form-control"
                placeholder="Input Hours" />
            </div>
            <div class="col-6 mt-4">
              <label class="form-label">Status</label>
              <v-select
                :options="statusOptions"
                v-model="bodyUpdate.status"
                label="text"
                :reduce="(e) => e.value"
                class="mr-2" />
            </div>
            <div class="col-6 mt-3">
              <label class="form-label">Description</label>
              <textarea
                v-model="bodyUpdate.description"
                type="text"
                class="form-control"
                placeholder="Input Description" />
            </div>
          </div>
        </div>
        <b-button class="float-end" variant="primary" @click="updateTraining()"
          >Update
        </b-button>
      </b-modal>

      <!-- Add Schedule -->
      <b-modal
        v-model="isAddSchedule"
        title="List of Schedule"
        size="xl"
        hide-footer
        @hide="clearSelectedRow">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="4">
                <b-card-title>Title</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.title
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4">
                <b-card-title>Status</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.is_active ? "Active" : "Non-active"
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4">
                <b-card-title>Training Method</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.training_method_name
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="mt-4">
                <b-card-title>Provider</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.provider_name
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4" class="mt-4">
                <b-card-title>Learning Hours</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.hour
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4" class="mt-4">
                <b-card-title>Training Type</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.training_type_name
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
            </b-row>

            <h3 class="mt-5">Batch List</h3>
            <b-row class="mt-4">
              <b-col md="4">
                <label class="form-label">Filter By Year</label>
                <v-select
                  v-model="selectedYear"
                  :options="yearOptions"
                  placeholder="Select Year">
                </v-select>
              </b-col>
              <b-col md="8">
                <div class="float-end mt-4">
                  <b-button @click="showCreateEvent()" variant="primary">
                    <span class="fe fe-plus"></span>
                    Create Event
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <div class="table-responsive">
              <table class="table table-sm table-bordered table-nowrap mt-4">
                <thead>
                  <tr>
                    <th>Batch</th>
                    <th>Penyelenggara</th>
                    <th>Quota</th>
                    <th>Remaining Quota</th>
                    <th>Used Quota</th>
                    <th>Schedule</th>
                    <th>Status</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="filteredEventList.length > 0">
                  <tr v-for="(item, index) in filteredEventList" :key="index">
                    <td>{{ item.batch }}</td>
                    <td>{{ item.penyelenggara || '-' }}</td>
                    <td>{{ item.quota }}</td>
                    <td>{{ item.remaining_quota }}</td>
                    <td>{{ item.used_quota }}</td>
                    <td>
                      <div
                        v-for="schedule in item.schedule"
                        :key="schedule.training_event_id">
                        <strong>{{ formatDate(schedule.date) }}</strong>
                        <div>
                          {{ formatTime(schedule.start_time) }} -
                          {{ formatTime(schedule.end_time) }}
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <h2>
                        <span :class="getBadgeStatusStructured(item.status)">
                          {{ capitalizeStatus(item.status) }}
                        </span>
                      </h2>
                    </td>
                    <td class="text-center">
                      <button
                        v-if="item.status != 'active'"
                        class="btn btn-sm btn-warning mx-1 my-1"
                        @click="showEditEvent(item)">
                        <span class="fe fe-edit"></span>
                      </button>
                      <button
                        class="btn btn-sm btn-danger mx-1 my-1"
                        @click="deleteEvent(item)">
                        <span class="fe fe-trash"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">No Data Available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </b-modal>

      <!-- Modal Propossed -->
      <b-modal
        v-model="isModalPropossed"
        title="List of Propossed"
        size="xl"
        hide-footer
        @hide="clearSelectedRow">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="4">
                <b-card-title>Title</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.title
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4">
                <b-card-title>Status</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.is_active ? "Active" : "Non-active"
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4">
                <b-card-title>Training Method</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.training_method
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="mt-4">
                <b-card-title>Provider</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.provider_name
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4" class="mt-4">
                <b-card-title>Learning Hours</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.hour
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
              <b-col md="4" class="mt-4">
                <b-card-title>Platform</b-card-title>
                <b-card-text v-if="selectedRow">{{
                  selectedRow.platform
                }}</b-card-text>
                <b-card-text v-else>No data available</b-card-text>
              </b-col>
            </b-row>

            <h3 class="mt-5">Propossed List</h3>
            <div class="table-responsive">
              <table class="table table-sm table-bordered table-nowrap mt-4">
                <thead>
                  <tr>
                    <th>NIK</th>
                    <th>Employee</th>
                    <th>Position</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody v-if="listPropossed.length > 0">
                  <tr v-for="(item, index) in listPropossed" :key="index">
                    <td>{{ item.nik }}</td>
                    <td>{{ item.employee_name }}</td>
                    <td>{{ item.position_title }}</td>
                    <td>{{ item.date }}</td>
                    <!-- <td>
                      <div
                        v-for="schedule in item.schedule"
                        :key="schedule.training_event_id">
                        <strong>{{ formatDate(schedule.date) }}</strong>
                        <div>
                          {{ formatTime(schedule.start_time) }} -
                          {{ formatTime(schedule.end_time) }}
                        </div>
                      </div>
                    </td> -->
                    <!-- <td class="text-center">
                      <h2>
                        <span :class="getBadgeStatusStructured(item.status)">
                          {{ capitalizeStatus(item.status) }}
                        </span>
                      </h2>
                    </td>
                    <td class="text-center">
                      <button
                        v-if="item.status != 'active'"
                        class="btn btn-sm btn-warning mx-1 my-1"
                        @click="showEditEvent(item)">
                        <span class="fe fe-edit"></span>
                      </button>
                      <button
                        class="btn btn-sm btn-danger mx-1 my-1"
                        @click="deleteEvent(item)">
                        <span class="fe fe-trash"></span>
                      </button>
                    </td> -->
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">No Data Available</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </b-modal>

      <!-- Modal Edit Event -->
    <b-modal
      v-model="isEditEvent"
      title="Edit Event"
      size="lg"
      hide-footer
      @hide="clearEnrollModal">
      <!-- {{ selectedRow }} -->
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyEnroll.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
              disabled />
          </div>
          <div class="col-6">
            <label class="form-label">Training Provider</label>
            <input
              v-model="bodyEnroll.trainingProvider"
              type="text"
              class="form-control"
              placeholder="Training Provider"
              disabled />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method <span class="text-danger">*</span></label>
            <v-select
              v-model="bodyEditEvent.trainingMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Price <span class="text-danger">*</span></label>
            <input
              v-model="bodyEditEvent.price"
              type="number"
              class="form-control"
              placeholder="Price" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Location <span class="text-danger">*</span></label>
            <input
              v-model="bodyEditEvent.location"
              type="text"
              class="form-control"
              placeholder="Location" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Quota <span class="text-danger">*</span></label>
            <input
              v-model="bodyEditEvent.quota"
              type="number"
              class="form-control"
              placeholder="Quota" />
          </div>
        </div>
        <div class="mt-4">
          <b-button @click="showScheduleModal" variant="primary"
            ><span class="fe fe-plus"></span>Add Schedule</b-button
          >
        </div>

        <!-- Schedule Table -->
        <div class="mt-4">
          <h4>Schedule</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th style="width: 50px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="scheduleList.length === 0">
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
              <tr v-else v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <!-- Modal Schedule -->
      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date <span class="text-danger">*</span></p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time <span class="text-danger">*</span></p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time <span class="text-danger">*</span></p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal>
      <div class="mt-4 float-end">
        <b-button class="mr-3" @click="isEditEvent = false" variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="editEvents" variant="primary"
          ><span class="fe fe-save mr-1"></span>Update</b-button
        >
      </div>
    </b-modal>

    
    </div>
  </div>
</template>
<script>
export default {
  name: "masterData-Training",
  computed: {
    filteredEventList() {
      if (!this.selectedYear) {
        return this.eventList;
      }
      return this.eventList.filter((event) => event.year === this.selectedYear);
    },
    isLmsIdRequired() {
      return this.bodyAdd.provider === "001"; // LMS ID mandatory only if provider is '001'
    },
    isLmsIdUpdateRequired() {
      return this.bodyUpdate.provider === "001"; // LMS ID mandatory only if provider is '001'
    }
  },
  data() {
    return {
      isLoading: false,
      body: {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        order: "",
        field: "",
        platform: "",
        provider: "",
        training_method: "",
        training_type: "",
        status: ""
      },
      statusOptions: [
        { text: "Active", value: true },
        { text: "Non-active", value: false }
      ],
      isModalPropossed: false,
      listPropossed: [],
      bodyEnroll: {
        id: "",
        trainingTitle: "",
        trainingProvider: "",
        trainingMethod: "",
        price: "",
        location: ""
      },
      bodyEvent: {
        trainingId: "",
        trainingMethod: "",
        location: "",
        price: "",
        quota: ""
      },
      bodyEditEvent: {
        trainingId: "",
        trainingMethod: "",
        location: "",
        price: "",
        quota: ""
      },
      isEditEvent: false,
      editEvent: '',
      currencies: ["USD", "IDR"],
      yearOptions: ["2023", "2024", "2025", "2026"],
      displayAmountAdd: "",
      displayAmountUpdate: "",
      dataTrainingType: [],
      dataTrainingMethod: [],
      selectedLearning: null,
      trainingId: "",
      dataTraining: [],
      dataProvider: [],
      dataCompetency: [],
      selectedRow: null,
      eventList: [],
      selectedYear: "2025",
      training: [],
      coaches: [],
      selectedCoach: null,
      isCreateModal: false,
      isUpdateModal: false,
      isAddSchedule: false,
      isRoleModalVisible: false,
      isEnrollModalVisible: false,
      isScheduleModalVisible: false,
      competencyData: [],
      experientialType: [],
      projectRole: [],
      projectData: [],
      roleList: [],
      scheduleList: [],
      listTabMenu: {},
      role: {
        position: "",
        total: ""
      },
      schedule: {
        date: null,
        startTime: null,
        endTime: null
      },
      bodyAdd: {
        lms_id: "",
        relatedCompetency: "",
        projectName: "",
        projectDescription: "",
        startDate: "",
        endDate: "",
        projectInvolvement: "",
        subordinate: "",
        bussinessNeed: "",
        objectives: "",
        goals: "",
        scope: "",
        constraints: "",
        deliverables: "",
        projectImpactA: "",
        impact: "",
        projectImpactB: "",
        projectImpact: "",
        attachment: [],
        coaching: "",
        competency: [
          {
            id:"",
            proficiency:[],
          },
        ],
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: 0,
        websiteTraining: "",
        description: "",
        hours: "",
        proficiency: []
      },
      bodyUpdate: {
        id: "",
        lms_id: "",
        relatedCompetency: "",
        projectName: "",
        projectDescription: "",
        startDate: "",
        endDate: "",
        projectInvolvement: "",
        subordinate: "",
        bussinessNeed: "",
        objectives: "",
        goals: "",
        scope: "",
        constraints: "",
        deliverables: "",
        projectImpactA: "",
        impact: "",
        projectImpactB: "",
        projectImpact: "",
        attachment: [],
        coaching: "",
        competency: [
          {
            id:"",
            proficiency:[],
          },
        ],
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: 0,
        websiteTraining: "",
        description: "",
        hours: "",
        proficiency: []
      },
      isAdd: true,
      isLoading: false,
      columns: [
        {
          label: "Training Title",
          field: "title",
          thClass: "table-header text-muted w-25 font-weight-bold ",
          tdClass: "color-secondary"
        },
         {
          label: "Platform",
          field: "platform",
          thClass: "table-header text-muted w-20 font-weight-bold ",
          tdClass: "color-secondary"
        },
        {
          label: "Provider",
          field: "provider_name",
          thClass: "table-header text-muted w-20 font-weight-bold ",
          tdClass: "color-secondary"
        },
       
        {
          label: "Training Method",
          field: "training_method",
          thClass: "table-header text-muted w-15 font-weight-bold text-nowrap ",
          tdClass: "color-secondary text-center"
        },
        {
          label: "Training Type",
          field: "training_type",
          thClass: "table-header text-muted w-15 font-weight-bold text-nowrap ",
          tdClass: "color-secondary text-center"
        },
        {
          label: "Learning Hours",
          field: "hour",
          thClass: "table-header text-muted w-15 font-weight-bold ",
          tdClass: "color-secondary text-center"
        },
        {
          label: "Status",
          field: "is_active",
          thClass: "table-header text-muted w-15 font-weight-bold ",
          tdClass: "color-secondary text-nowrap"
        },
        {
          label: "Action",
          field: "action",
          thClass: "table-header text-muted w-5 font-weight-bold ",
          tdClass: "color-secondary"
        }
      ]
    };
  },
  mounted() {
    //  this.getCoaches();
    this.getCompetency();
    this.getProvider();
    this.getTrainingMethod();
    this.getTrainingType();
    // this.getExperientialType();
    // this.getRole();
    this.getTraining();
    this.displayAmountAdd = this.formatCurrency(this.bodyAdd.price);
    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu.children.find((item) => item.link === currentPath);
  },
  watch: {
    selectedYear(newVal) {
      // console.log('Selected year:', newVal);
    },
    "bodyAdd.provider"(newVal) {
      if (newVal !== "001") {
        this.bodyAdd.lms_id = ""; // Reset lms_id if provider is not '001'
      }
    },
    "bodyUpdate.provider"(newVal) {
      if (newVal !== "001") {
        // this.bodyUpdate.lms_id = ""; // Reset lms_id if provider is not '001'
      }
    },
    "bodyAdd.currency": function () {
      this.displayAmountAdd = this.formatCurrency(this.bodyAdd.price);
    },
    "bodyUpdate.currency": function () {
      this.displayAmountUpdate = this.formatCurrency(this.bodyUpdate.price);
    },
    "bodyAdd.startDate": "calculateDuration",
    "bodyAdd.endDate": "calculateDuration"
  },
  methods: {
    clearFilter(){
      this.body = {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        order: "",
        field: "",
        platform: "",
        provider: "",
        training_method: "",
        training_type: "",
      };
      this.getTraining();
    },
    showEditEvent(item) {
      this.bodyEnroll.trainingTitle = item.training_name;
      this.bodyEnroll.trainingProvider = item.training_provider;
      this.isEditEvent = true;
      this.bodyEditEvent.trainingId = this.selectedRow.id;
      this.bodyEditEvent.id = item.id;
      this.bodyEditEvent.trainingMethod = item.training_method;
      this.bodyEditEvent.location = item.location;
      this.bodyEditEvent.price = item.price;
      this.bodyEditEvent.quota = item.quota;
      this.scheduleList = (item.schedule || []).map((schedule) => ({
        date: this.formatDateTime(schedule.date),
        startTime: this.formatTime(schedule.start_time),
        endTime: this.formatTime(schedule.end_time)
      }));
    },
    getBadgeStatus(value) {
      if (!value) return "";
      const status = value;

      if (status.replace(/\s+/g, '') === "SelfLearning") {
        return "badge bg-success  align-items-center";
      } else if (status.replace(/\s+/g, '') === "In-ClassLearning") {
        return "badge bg-warning text-dark  align-items-center";
      } else if (status.replace(/\s+/g, '') === "OnlineLearning") {
        return "badge bg-secondary  align-items-center";
      } else if (status.replace(/\s+/g, '') === "In-HouseLearning") {
        return "badge bg-info  align-items-center";
      } else if (status === "Seminar") {
        return "badge bg-danger  align-items-center";
      } else if (status === "Workshop") {
        return "badge bg-success  align-items-center";
      } else if (status === "Training") {
        return "badge bg-secondary  align-items-center";
      } else if (status === "Certification") {
        return "badge bg-info  align-items-center";
      } else if (status === "Semi Certification") {
        return "badge bg-success  align-items-center";
      } else if (status === "Trainings") {
        return "badge bg-warning text-dark  align-items-center";
      }

      return "";
    },
    getIconClass(value) {
      if (!value) return "";
      const status = value.replace(/\s+/g, '');
      switch (status) {
        case "SelfLearning":
          return "fe fe-check-circle";
        case "In-ClassLearning":
          return "fe fe-file-text";
        case "OnlineLearning":
          return "fe fe-user-check";
        case "In-HouseLearning":
          return "fe fe-home";
        case "Seminar":
          return "fe fe-user";
        case "Workshop":
          return "fe fe-send";
        case "Training":
          return "fe fe-check";
        case "Certification":
          return "fe fe-book";
        case "SemiCertification":
          return "fe fe-book-open";
        case "Trainings":
          return "fe fe-lock";
        default:
          return "";
      }
    },
    getBadgeStatusStructured(value) {
      // const status = value.toLowerCase();
      if (value === "completed") {
        return "badge bg-info";
      } else if (value === "draft") {
        return "badge bg-warning";
      } else if (value === "registered") {
        return "badge bg-secondary";
      } else if (value === "rejected") {
        return "badge bg-danger";
      } else if (value === "submitted") {
        return "badge bg-success";
      } else if (value === "approved") {
        return "badge bg-success";
      } else if (value === "active") {
        return "badge bg-success";
      }
      return "";
    },
    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    formatSchedule(scheduleList) {
      return scheduleList.map((item) => {
        const date = new Date(item.date);
        const formattedDate = date.toISOString().split("T")[0];
        const formattedStartTime = `${item.startTime}:00+07`;
        const formattedEndTime = `${item.endTime}:00+07`;

        return {
          date: this.formatDateTime(date),
          start_time: formattedStartTime,
          end_time: formattedEndTime
        };
      });
    },
    formatDateTime(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },

    formatTime(time) {
      const [hour, minute] = time.split(":");
      return `${hour}:${minute}`;
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    submitEvent() {
      // Validasi field mandatory
      if (!this.bodyEvent.trainingMethod) {
        this.$swal("Error", "Metode pelatihan wajib diisi", "error");
        return;
      }
      
      if (!this.bodyEvent.price || this.bodyEvent.price <= 0) {
        this.$swal("Error", "Harga wajib diisi dan harus lebih dari 0", "error");
        return;
      }
      
      if (!this.bodyEvent.location || this.bodyEvent.location.trim() === "") {
        this.$swal("Error", "Lokasi wajib diisi", "error");
        return;
      }
      
      if (!this.bodyEvent.quota || this.bodyEvent.quota <= 0) {
        this.$swal("Error", "Kuota wajib diisi dan harus lebih dari 0", "error");
        return;
      }

      if (this.scheduleList.length === 0) {
        this.$swal("Error", "Minimal satu jadwal wajib diisi", "error");
        return;
      }

      const formattedSchedule = this.formatSchedule(this.scheduleList);
      let requestData = {
        training_id: this.bodyEvent.trainingId,
        training_method: this.bodyEvent.trainingMethod,
        location: this.bodyEvent.location,
        price: Number(this.bodyEvent.price),
        quota: this.bodyEvent.quota,
        schedule: formattedSchedule
      };
      this.$store
        .dispatch("myIdp/createTrainingEvent", requestData)
        .then((response) => {
          this.$swal("Success", "Event berhasil dibuat", "success");
          this.isEnrollModalVisible = false;
          // this.isModalVisible = false;
          this.clearEnrollModal();
          this.getEventByHr(this.trainingId);

          // this.getDataIdpPersonal();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Event belum berhasil dibuat: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    addSchedule() {
      // Validasi field mandatory untuk schedule
      if (!this.schedule.date) {
        this.$swal("Error", "Tanggal wajib diisi", "error");
        return;
      }
      
      if (!this.schedule.startTime) {
        this.$swal("Error", "Waktu mulai wajib diisi", "error");
        return;
      }
      
      if (!this.schedule.endTime) {
        this.$swal("Error", "Waktu selesai wajib diisi", "error");
        return;
      }

      const startTimeMoment = this.$moment(this.schedule.startTime);
      const endTimeMoment = this.$moment(this.schedule.endTime);

      if (startTimeMoment.isAfter(endTimeMoment)) {
        this.$swal("Error", "Waktu mulai tidak boleh lebih besar dari waktu selesai", "error");
        return;
      }
      
      const formattedSchedule = {
        date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
        startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
        endTime: this.$moment(this.schedule.endTime).format("HH:mm")
      };
      this.scheduleList.push(formattedSchedule);
      this.clearScheduleModal();
      this.isScheduleModalVisible = false;
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    clearEnrollModal() {
      this.bodyEnroll.trainingTitle = "";
      this.bodyEnroll.trainingProvider = "";
      this.bodyEnroll.trainingMethod = "";
      this.bodyEnroll.location = "";
      this.bodyEnroll.price = "";
      this.bodyEnroll.schedule = [];
      this.bodyEnroll.checkedParticipants = [];
      this.selectedParticipants = [];
      this.scheduleList = [];
      this.selectedRows = [];
    },
    showCreateEvent() {
      this.bodyEnroll.id = this.selectedRow.id;
      // this.selectedParticipants = this.selectedRow.participants.filter(
      //   (participant) => this.selectedRows.includes(participant.id)
      // );
      this.bodyEnroll.trainingTitle = this.selectedRow.title;
      this.bodyEnroll.trainingProvider = this.selectedRow.provider_name;
      this.bodyEvent.trainingMethod = this.selectedRow.training_method;
      this.bodyEvent.price = this.selectedRow.price;
      this.isEnrollModalVisible = true;
    },
    getEventByHr(id) {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getEventByHr", { id: id })
        .then((res) => {
          this.eventList = res.data;
          this.isEmpty = !this.eventList || this.eventList.length === 0;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error get event data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    viewDetailsPropossed(row) {
      this.$store.dispatch("training/detailTrainingPropossed", row.id).then((resp) => {
        let data = this.$store.getters["training/DetailTrainingPropossed"].data;
        this.listPropossed = data;
        this.trainingId = row.id;
        this.selectedRow = row;
        this.bodyEvent.trainingId = row.id;
        this.isModalPropossed = true;
      });
    },
    viewDetails(row) {
      this.$store.dispatch("training/detailTraining", row.id).then((resp) => {
        let data = this.$store.getters["training/DetailTraining"].data;
        this.trainingId = row.id;
        this.selectedRow = data;
        this.bodyEvent.trainingId = row.id;
        // this.bodyUpdate.id = row.id;
        // this.bodyUpdate.hours = data.hour;
        // this.bodyUpdate.status = data.is_active;
        // this.bodyUpdate.title = data.title;
        // this.bodyUpdate.competency = data.proficiency[0]?.competency_id || "";
        // this.bodyUpdate.proficiency = data.proficiency.map(
        //   (item) => item.proficiency
        // );
        // this.bodyUpdate.provider = data.provider_id;
        // this.bodyUpdate.providerName = data.provider_name;
        // this.bodyUpdate.address = data.address;
        // this.bodyUpdate.website = data.website;
        // this.bodyUpdate.contactPerson = data.contactPerson;
        // this.bodyUpdate.email = data.email;
        // this.bodyUpdate.phone = data.phone;
        // this.bodyUpdate.trainingName = data.trainingName;
        // this.bodyUpdate.learningMethod = data.training_method;
        // this.bodyUpdate.learningType = data.training_type;
        // this.bodyUpdate.currency = data.currency;
        // this.bodyUpdate.price = data.price;
        // this.bodyUpdate.websiteTraining = data.website;
        // this.bodyUpdate.description = data.description;
      });
      // console.log("rownya", row);

      this.getEventByHr(row.id);
      this.isAddSchedule = true;
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(price);
    },
    clearSelectedRow() {
      this.selectedRow = null;
    },
    formatCurrency(value) {
      // console.log(`Type of value yang masuk: ${typeof value}`);

      if (typeof value === 'string') {
        value = parseFloat(value);
      }

      if (typeof value !== 'number' || isNaN(value)) {
        throw new Error('Value must be a number or a numeric string');
      }

      value = Math.floor(value);

      if (!value || value === 0) {
        return new Intl.NumberFormat(
          this.bodyAdd.currency === "IDR" || this.bodyUpdate.currency === "IDR" ? "id-ID" : "en-US",
          {
            style: "currency",
            currency: this.bodyAdd.currency || this.bodyUpdate.currency,
            minimumFractionDigits: 0 
          }
        ).format(0); 
      }

      const formatter = new Intl.NumberFormat(
        this.bodyAdd.currency === "IDR" || this.bodyUpdate.currency === "IDR" ? "id-ID" : "en-US",
        {
          style: "currency",
          currency: this.bodyAdd.currency || this.bodyUpdate.currency,
          minimumFractionDigits: 0 
        }
      );

      return formatter.format(value);
    },

    editEvents() {
      // Validasi field mandatory
      if (!this.bodyEditEvent.trainingMethod) {
        this.$swal("Error", "Metode pelatihan wajib diisi", "error");
        return;
      }
      
      if (!this.bodyEditEvent.price || this.bodyEditEvent.price <= 0) {
        this.$swal("Error", "Harga wajib diisi dan harus lebih dari 0", "error");
        return;
      }
      
      if (!this.bodyEditEvent.location || this.bodyEditEvent.location.trim() === "") {
        this.$swal("Error", "Lokasi wajib diisi", "error");
        return;
      }
      
      if (!this.bodyEditEvent.quota || this.bodyEditEvent.quota <= 0) {
        this.$swal("Error", "Kuota wajib diisi dan harus lebih dari 0", "error");
        return;
      }
      
      const formattedSchedule = this.formatSchedule(this.scheduleList);
      let requestData = {
        id: this.bodyEditEvent.id,
        training_id: this.bodyEditEvent.trainingId,
        training_method: this.bodyEditEvent.trainingMethod,
        location: this.bodyEditEvent.location,
        price: Number(this.bodyEditEvent.price),
        quota: this.bodyEditEvent.quota,
        schedule: formattedSchedule
      };
      this.$store
        .dispatch("myIdp/editTrainingEvent", requestData)
        .then((response) => {
          this.$swal("Success", "Event berhasil diubah", "success");
          this.isEditEvent = false;
          this.getTraining();
          this.getEventByHr(this.trainingId);
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Event belum berhasil diubah: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },

    unformatCurrency(value) {
      return value.replace(/[^\d]/g, "");
    },
    updateAmount(event) {
      // console.log(event.target.value);
      const inputValue = event.target.value;
      const unformattedValue = this.unformatCurrency(inputValue);
      console.log(unformattedValue)

      this.bodyAdd.price = parseInt(unformattedValue) || 0;
      this.bodyUpdate.price = parseInt(unformattedValue) || 0;

      if(this.bodyAdd.currency == 'IDR' || this.bodyUpdate.currency == 'IDR') {
        this.displayAmountAdd = this.formatCurrency(this.bodyAdd.price);
        this.displayAmountUpdate = this.formatCurrency(this.bodyUpdate.price);
      } else {
        this.displayAmountAdd = this.bodyAdd.price;
        this.displayAmountUpdate =this.bodyUpdate.price;
      }
      // this.displayAmountAdd = this.formatCurrency(this.bodyAdd.price);
      // this.displayAmountUpdate = this.formatCurrency(this.bodyUpdate.price);
    },

    addCompetency() {
      let body = {
        id: "",
        proficiency: ""
      }
      this.bodyAdd.competency.push(body)
    },

    delCompetency(index) {
      this.bodyAdd.competency.splice(index, 1)
    },

    toggleProficiency(value, compIndex) {
      // const index = this.bodyAdd.competency[compIndex].proficiency.indexOf(value);
      // if (index === -1) {
      //   this.bodyAdd.competency[compIndex].proficiency.push(value);
      // } else {
      //   this.bodyAdd.competency[compIndex].proficiency.splice(index, 1);
      // }
      const competencyItem = this.bodyAdd.competency[compIndex];
      if (!Array.isArray(competencyItem.proficiency)) {
        this.$set(competencyItem, 'proficiency', []);
      }

      const proficiencyIndex = competencyItem.proficiency.indexOf(value);
      if (proficiencyIndex === -1) {
        competencyItem.proficiency.push(value);
      } else {
        competencyItem.proficiency.splice(proficiencyIndex, 1);
      }
    },

    addCompetencyUpdate() {
      let body = {
        id: "",
        proficiency: ""
      }
      this.bodyUpdate.competency.push(body)
    },

    delCompetencyUpdate(index) {
      this.bodyUpdate.competency.splice(index, 1)
    },

    toggleProficiencyUpdate(value, compIndex) {
      // const index = this.bodyAdd.competency[compIndex].proficiency.indexOf(value);
      // if (index === -1) {
      //   this.bodyAdd.competency[compIndex].proficiency.push(value);
      // } else {
      //   this.bodyAdd.competency[compIndex].proficiency.splice(index, 1);
      // }
      const competencyItem = this.bodyUpdate.competency[compIndex];
      if (!Array.isArray(competencyItem.proficiency)) {
        this.$set(competencyItem, 'proficiency', []);
      }

      const proficiencyIndex = competencyItem.proficiency.indexOf(value);
      if (proficiencyIndex === -1) {
        competencyItem.proficiency.push(value);
      } else {
        competencyItem.proficiency.splice(proficiencyIndex, 1);
      }
    },
    getCoaches() {
      this.$store
        .dispatch("employee/getEmployees", { search: "" })
        .then((response) => {
          this.coaches = response.data;
        });
    },
    onCoachSelect(selectedCoach) {
      if (selectedCoach) {
        this.bodyAdd.nik = selectedCoach;
      } else {
        this.bodyAdd.nik = "";
      }
    },
    clearProjectModal() {
      this.bodyAdd.title = "";
      this.bodyAdd.nik = "";
      this.bodyAdd.methodology = "";
      this.bodyAdd.startDate = "";
      this.bodyAdd.endDate = "";
      this.bodyAdd.role = "";
      this.roleList = [];
      this.bodyAdd.competency = "";
    },
    addTraining() {
      this.isCreateModal = true;
    },
    calculateDuration() {
      if (this.bodyAdd.startDate && this.bodyAdd.endDate) {
        const startDate = new Date(this.bodyAdd.startDate);
        const endDate = new Date(this.bodyAdd.endDate);

        // Cek jika startDate dan endDate sama
        if (startDate.getTime() === endDate.getTime()) {
          this.bodyAdd.duration = 1; // Set duration ke 1 jika tanggal sama
        } else {
          const diffTime = Math.abs(endDate - startDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          this.bodyAdd.duration = diffDays;
        }
      } else {
        this.bodyAdd.duration = "";
      }
    },
    createTraining() {
      this.$swal({
        title: "Buat Pelatihan",
        text: "Apakah Anda yakin ingin membuat pelatihan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          let requestData = {};

          // To avoid error when provider is other
          if (this.bodyAdd.provider === "Other") this.bodyAdd.provider = null;

          if (this.bodyAdd.provider && !this.selectedLearning) {
            let trainingObject = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteProvider,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
              is_active: this.bodyAdd.status
            };

            if (this.bodyAdd.lms_id) {
              trainingObject.lms_id = this.bodyAdd.lms_id;
            }

            requestData = {
              competency: this.bodyAdd.competency,
              proficiency: this.bodyAdd.proficiency,
              provider: this.bodyAdd.provider,
              training: trainingObject
            };
          } else if (!this.bodyAdd.provider && !this.selectedLearning) {
            let trainingObject = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteTraining,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
              is_active: this.bodyAdd.status
            };

            if (this.bodyAdd.lms_id) {
              trainingObject.lms_id = this.bodyAdd.lms_id;
            }

            requestData = {
              competency: this.bodyAdd.competency,
              proficiency: this.bodyAdd.proficiency,
              provider: {
                name: this.bodyAdd.providerName,
                address: this.bodyAdd.address,
                website: this.bodyAdd.websiteProvider,
                contact_person: this.bodyAdd.contactPerson,
                email: this.bodyAdd.email,
                phone: this.bodyAdd.phone
              },
              training: trainingObject
            };
          }
          if (this.isLmsIdRequired && !this.bodyAdd.lms_id) {
            this.$swal.fire({
              icon: "error",
              title: "Validasi Gagal",
              text: "ID penyedia pelatihan wajib diisi jika provider adalah Ugems University."
            });
            return; 
          }
          // return console.log("req data => ",requestData)
          this.$store
            .dispatch("training/createTraining", requestData)
            .then((response) => {
              this.$swal
                .fire({
                  icon: "success",
                  title: "Success",
                  text: "Pelatihan berhasil dibuat."
                })
                .then(() => {
                  this.getTraining();
                  this.resetForm();
                  // Get New Provider
                  this.getProvider();
                });
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Terjadi kesalahan saat membuat aspirasi pelatihan."
              });
            });
        }
      });
    },
    updateTraining() {
      this.$swal({
        title: "Perbarui Pelatihan",
        text: "Apakah Anda yakin ingin memperbarui pelatihan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
         
            if (typeof this.bodyUpdate.price === 'string') {
        this.bodyUpdate.price = parseFloat(this.bodyUpdate.price).toFixed(0);
        this.bodyUpdate.price = parseFloat(this.bodyUpdate.price);
      }
          let requestData = {};

          if (this.bodyUpdate.provider && !this.selectedLearning) {
            let trainingObject = {
              title: this.bodyUpdate.trainingName,
              training_type: this.bodyUpdate.learningType,
              training_method: this.bodyUpdate.learningMethod,
              currency: this.bodyUpdate.currency,
              price: this.bodyUpdate.price,
              website: this.bodyUpdate.websiteTraining,
              description: this.bodyUpdate.description,
              hours: this.bodyUpdate.hours,
              is_active: this.bodyUpdate.status
            };

            // Add lms_id only if it exists
            if (this.bodyUpdate.lms_id) {
              trainingObject.lms_id = this.bodyUpdate.lms_id;
            }

            requestData = {
              competency: this.bodyUpdate.competency,
              proficiency: this.bodyUpdate.proficiency,
              provider: this.bodyUpdate.provider,
              training: trainingObject
            };
          } else if (!this.bodyUpdate.provider && !this.selectedLearning) {
            let trainingObject = {
              title: this.bodyUpdate.trainingName,
              training_type: this.bodyUpdate.learningType,
              training_method: this.bodyUpdate.learningMethod,
              currency: this.bodyUpdate.currency,
              price: this.bodyUpdate.price,
              website: this.bodyUpdate.websiteTraining,
              description: this.bodyUpdate.description,
              hours: this.bodyUpdate.hours,
              is_active: this.bodyUpdate.status
            };

            // Add lms_id only if it exists
            if (this.bodyUpdate.lms_id) {
              trainingObject.lms_id = this.bodyUpdate.lms_id;
            }

            requestData = {
              competency: this.bodyUpdate.competency,
              proficiency: this.bodyUpdate.proficiency,
              provider: {
                id: this.bodyUpdate.provider,
                name: this.bodyUpdate.providerName,
                address: this.bodyUpdate.address,
                website: this.bodyUpdate.websiteProvider,
                contact_person: this.bodyUpdate.contactPerson,
                email: this.bodyUpdate.email,
                phone: this.bodyUpdate.phone
              },
              training: trainingObject
            };
          }

          let data = {
            id: this.bodyUpdate.id,
            requestData: requestData
          };
          if (this.isLmsIdUpdateRequired && !this.bodyUpdate.lms_id) {
            this.$swal.fire({
              icon: "error",
              title: "Validasi Gagal",
              text: "ID penyedia pelatihan wajib diisi jika provider adalah Ugems University."
            });
            return; 
          }
          // return console.log("req data => ", data);

          this.$store
            .dispatch("training/updateTraining", data)
            .then((response) => {
              this.$swal
                .fire({
                  icon: "success",
                  title: "Success",
                  text: "Pelatihan berhasil diperbarui."
                })
                .then(() => {
                  this.getTraining();
                  this.resetForm();
                });
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Terjadi kesalahan saat memperbarui aspirasi pelatihan."
              });
            });
        }
      });
    },

    findRoleDetails(positionId) {
      const role = this.projectRole.find((role) => role.id === positionId);
      return role ? { name: role.name, id: role.id } : { name: "", id: null };
    },
    selectTraining(training) {
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    resetForm() {
      (this.bodyAdd = {
        relatedCompetency: "",
        projectName: "",
        projectDescription: "",
        startDate: "",
        endDate: "",
        projectInvolvement: "",
        subordinate: "",
        bussinessNeed: "",
        objectives: "",
        goals: "",
        scope: "",
        constraints: "",
        deliverables: "",
        projectImpactA: "",
        impact: "",
        projectImpactB: "",
        projectImpact: "",
        attachment: [],
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: 0,
        websiteTraining: "",
        description: "",
        hours: "",
        proficiency: []
      }),
        (this.selectedLearning = null);
      this.isCreateModal = false;
      this.isUpdateModal = false;
    },
    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch(
              "trainingProvider/getTrainingByProvider",
              {
                providerId: this.bodyAdd.provider,
                search
              }
            );
            this.dataTraining =
              this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find(
        (provider) => provider.id === selectedProviderId
      );
      console.log("selectedProvider", selectedProvider);
      if (selectedProvider) {
        this.bodyUpdate.providerName =
          selectedProvider.name === "Other" ? "" : selectedProvider.name;
        this.bodyUpdate.address = selectedProvider.address;
        this.bodyUpdate.websiteProvider = selectedProvider.website;
        this.bodyUpdate.contactPerson = selectedProvider.contact_person;
        this.bodyUpdate.email = selectedProvider.email;
        this.bodyUpdate.phone = selectedProvider.phone;
      }
    },
    addRole() {
      const roleDetails = this.findRoleDetails(this.role.position);
      const body = {
        position: roleDetails.name,
        total: this.role.total,
        positionId: roleDetails.id
      };
      console.log("isibodiaddrole", body);
      this.roleList.push(body);
      this.clearRoleModal();
      this.isRoleModalVisible = false;
    },
    removeRole(index) {
      this.roleList.splice(index, 1);
    },
    showRoleModal() {
      this.isRoleModalVisible = true;
    },
    clearRoleModal() {
      this.role = { position: "", total: "" };
    },
    updateData(props) {
      this.$store.dispatch("training/detailTraining", props.id).then((resp) => {
        let data = resp.data;
        
        this.bodyUpdate.id = props.id;
        this.bodyUpdate.hours = data.hour;
        this.bodyUpdate.status = data.is_active;
        this.bodyUpdate.title = data.title;
        this.bodyUpdate.lms_id = data.lms_id;
        console.log("datadetail update=>>", this.bodyUpdate);
        this.bodyUpdate.competency = data.competency.map((item) => {
          return {
            id: item.id,
            proficiency: item.proficiency
          }
        });
        // this.bodyUpdate.proficiency = data.proficiency.map(
        //   (item) => item.proficiency
        // );
        const providerdata = this.dataProvider.find(
          (provider) => provider.id === data.provider_id
        );
        this.bodyUpdate.provider = data.provider_id;
        this.bodyUpdate.providerName = providerdata.name;
        this.bodyUpdate.address = providerdata.address;
        this.bodyUpdate.websiteProvider = providerdata.website;
        this.bodyUpdate.contactPerson = providerdata.contact_person;
        this.bodyUpdate.email = providerdata.email;
        this.bodyUpdate.phone = providerdata.phone;

        this.bodyUpdate.trainingName = data.title;
        this.bodyUpdate.learningMethod = data.training_method;
        this.bodyUpdate.learningType = data.training_type;
        this.bodyUpdate.currency = data.currency;
        this.bodyUpdate.price = data.price;
         this.displayAmountUpdate = this.formatCurrency(this.bodyUpdate.price);
        this.bodyUpdate.websiteTraining = data.website;
        this.bodyUpdate.description = data.description;
      });
      this.isUpdateModal = true;
    },
    formatDate(date) {
      return this.$moment(date).format("DD-MM-YYYY");
    },
    saveAdd() {
      console.log("nik saat saveadd", this.bodyAdd.nik);
      let bodyAdd = {
        title: this.bodyAdd.title,
        coach_nik: this.bodyAdd.nik,
        methodology: this.bodyAdd.methodology,
        competency: this.bodyAdd.competency
      };
      console.log("body add", bodyAdd);
      this.$store
        .dispatch("myIdp/createCoaching", bodyAdd)
        .then((response) => {
          this.$swal("Success", "Coaching berhasil dibuat", "success");
          this.isCreateModal = false;
          this.clearProjectModal();
          this.getTraining();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Proyek belum berhasil dibuat: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },

    saveUpdate() {
      this.isLoading = true;
      this.$store
        .dispatch("role/updateRole", this.bodyUpdate)
        .then((resp) => {
          this.$swal({
            title: "Tersimpan",
            text: "Data berhasil disimpan",
            icon: "success",
            confirmButtonText: "OK"
          }).then((resp) => {
            this.isLoading = false;
            this.getCompetency();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.$swal("Error", "Gagal menambah data", "error");
        });
    },
    deleteEvent(item) {
      console.log("isinya", item);
      let idEvent = item.id;
      this.$swal({
        title: "Hapus Event",
        text: "Apakah Anda yakin ingin menghapus event yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/deleteTrainingEvent", idEvent)
            .then((response) => {
              console.log("totlol", response);
              this.$swal("Terhapus", "Event berhasil dihapus.", "success");
              this.getEventByHr(this.trainingId);
            })
            .catch((error) => {
              this.$swal("Error", "Hapus gagal. Silakan coba lagi.", "error");
            });
        }
      });
    },
    deleteData(id) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.$store
            .dispatch("role/delRole", id)
            .then((resp) => {
              this.isLoading = false;
              this.getCompetency();
              this.$swal("Terhapus", "Data berhasil dihapus", "success");
            })
            .catch((resp) => {
              this.$swal("Error", "Gagal menghapus data", "error");
            });
        }
      });
    },

    // api hit
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetency").then((res) => {
        this.dataCompetency = res.data;
      });
    },
    getExperientialType() {
      this.$store.dispatch("projectType/getTrainingType").then((res) => {
        this.experientialType = res.data;
      });
    },
    getRole() {
      this.$store.dispatch("projectRole/getTrainingRole").then((res) => {
        this.projectRole = res.data;
      });
    },
    getTraining() {
      this.$store.dispatch("training/getTraining", this.body).then((res) => {
        this.training = res.data;
      });
    },
    getProvider() {
      this.$store
        .dispatch("trainingProvider/getTrainingProviders")
        .then((res) => {
          // console.log("provid", res.data);
          res.data.push({
            id: "Other",
            name: "Other",
            address: null,
            contact_person: null,
            email: null,
            phone: null,
            website: null
          });
          this.dataProvider = res.data;
        });
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        this.dataTrainingType = res.data;
      });
    },

    // filter
    // filterPage() {
    //   this.getCompetency();
    // },
     onPageChange(payload) {
        this.body.pageSize = payload.currentPerPage
         this.body.pageNumber=payload.currentPage
         this.getTraining()
      },
      onSortChange(params) {
        let sort1 = params[0].field;
        let sort2 = params[0].type;
        this.body.field = `${sort1}`
        this.body.order = `${sort2}`
        this.getTraining();
      },

    sorting() {
      this.getCompetency();
      this.body.page = 1;
    },

    // Pagination
    // onPageChange(payload) {
    //   this.body.limit = payload.currentPerPage;
    //   this.body.page = payload.currentPage;
    //   this.getCompetency();
    //   // if (
    //   //   parseInt(payload.currentPage) * parseInt(payload.currentPerPage) >
    //   //   1000
    //   // ) {
    //   // }
    // }
  }
};
</script>
<style>
.button-container {
  display: flex;
}
.button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  cursor: pointer;
  margin: 0;
}
.button.active {
  background-color: red;
  color: white;
}
</style>
